import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import { shouldRenderExchangeRecommendationSelector } from '../ExchangeRecommendationTypeSelector/helpers'
import { getTaxonomyTypeOptions } from './helpers'
import * as Styles from './styles'

const TaxonomyTypeSelector = ({
  allowedPreferences,
  provider,
  configurationPreferences,
  allowedExchangeMethods,
  externalConnectedGateway,
  taxonomyType,
  onChangeTaxonomyType,
  availableTaxonomyTypes,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !shouldRenderExchangeRecommendationSelector({
      provider,
      configurationPreferences,
      allowedPreferences,
      allowedExchangeMethods,
      externalConnectedGateway,
    })
  ) {
    return null
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Navegación por productos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define cómo quieres que se ordene la navegación y la agrupación de los productos disponibles para solicitudes de cambio en el portal de devoluciones.'
        )}
      </Text>
      <ComboBox
        label={t('Agrupación de productos para navegación')}
        menuItems={getTaxonomyTypeOptions(availableTaxonomyTypes, t)}
        value={taxonomyType}
        fullWidth
        handleChange={e => onChangeTaxonomyType(e.target.value)}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default TaxonomyTypeSelector
